// extracted by mini-css-extract-plugin
module.exports = {"container":"PageWarning_container__rIOT2","warning":"PageWarning_warning__ZkWtr","whiteBg":"PageWarning_whiteBg__SSFbG"};